"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteFromOtherNodesDialog = void 0;
const react_1 = __importStar(require("react"));
const actions_with_other_nodes_dialog_1 = require("./partials/actions-with-other-nodes-dialog");
const product_tree_nodes_1 = require("../../../client/product-tree-nodes");
const context_1 = require("../../../context");
const localization_1 = require("../../../../localization");
const DeleteFromOtherNodesDialog = ({ isLoading, onClose, onSubmit, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { checkedIds = [], checkedItemTypeTitle, getCheckedAttributeValuesMap, } = (0, context_1.useCheckedAttributes)();
    const productTreeNodeFilter = (0, react_1.useMemo)(() => {
        const attributeValuesMap = getCheckedAttributeValuesMap();
        return attributeValuesMap ? (0, product_tree_nodes_1.buildFilterToIncludeFilterItems)(attributeValuesMap) : null;
    }, [getCheckedAttributeValuesMap]);
    const attributeFilter = (0, react_1.useMemo)(() => {
        const attributeValuesMap = getCheckedAttributeValuesMap();
        if (!attributeValuesMap) {
            return null;
        }
        return {
            some: {
                label: {
                    in: Object.keys(attributeValuesMap),
                },
            },
        };
    }, [getCheckedAttributeValuesMap]);
    const checkedItemsLength = checkedIds.length;
    const renderTreeNodeSecondaryText = (0, react_1.useCallback)(({ labelValidation }) => {
        var _a;
        let associatedAttributeName = '';
        if (checkedItemsLength > 1) {
            associatedAttributeName = (_a = labelValidation.edges) === null || _a === void 0 ? void 0 : _a.map(({ node: { label } }) => label).join(', ');
        }
        return associatedAttributeName && `(${associatedAttributeName})`;
    }, [checkedItemsLength]);
    return (react_1.default.createElement(actions_with_other_nodes_dialog_1.ActionsWithOtherNodesDialog, { error: true, productTreeNodeFilter: productTreeNodeFilter, attributesFilter: attributeFilter, renderTreeNodeSecondaryText: renderTreeNodeSecondaryText, title: t({ key: 'DIALOG_DELETE_FROM_OTHER_NODES_TITLE', values: { count: checkedItemsLength, entity: checkedItemTypeTitle } }), message: t({ key: 'DELETE_DIALOG_WARNING_MESSAGE' }), successSingleActionCompleteTitle: t({ key: 'DELETE_ENTITY_SUCCESS', values: { count: checkedItemsLength, entity: checkedItemTypeTitle } }), onSubmit: onSubmit, onClose: onClose, isLoading: isLoading }));
};
exports.DeleteFromOtherNodesDialog = DeleteFromOtherNodesDialog;
exports.default = exports.DeleteFromOtherNodesDialog;
